import type { Level } from "building-types/levels/levelTypes";
import type { Table } from "common/data/table";

export default function getStoryCount(levels: Table<Level>): number {
  return Object.values(levels).filter((level) => level.floorIndex >= 0).length;
}
